/**
 * @file main.tab.tsx
 * @description Основная таба формы версии тестового случая (test-case-version). 
 * Содержит описание изменений и особенностей конкретной версии тест-кейса с поддержкой вложений.
 * Позволяет документировать различия между релизами и спецификации для конкретных версий продукта.
 * Поддерживает drag-and-drop загрузку файлов через DragNDropZone.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies [react, @src/types, @components/form-controls/drag-n-drop-zone, @components/form-controls/collapsed/attachments-rich-text]
 * @related-files [@forms/test-case-version/test-case-version.form.tsx, @components/form-controls/drag-n-drop-zone/drag-n-drop-zone.component.tsx]
 */

import { tabProps } from '@src/types';
import { DragNDropZone } from '@components/form-controls/drag-n-drop-zone';
import { AttachmentsRichText } from '@components/form-controls/collapsed/attachments-rich-text';

export const Main = ({ control }: tabProps) => {
    return (
        <DragNDropZone className="flex flex-col h-full gap-[1.0585vmin]" name="attachments" control={control}>
            <AttachmentsRichText
                label="Описание"
                name="description"
                control={control}
                placeholder="Добавьте описание задачи, чтобы исполнителю было понятно, что нужно сделать в рамках задачи"
            />
        </DragNDropZone>
    );
};
